import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import { CommunitySectionsAvailabilityResponse } from "./types"

export const getCommunitySectionsAvailability = (): Promise<AxiosResponse<CommunitySectionsAvailabilityResponse>> => {
    return apiInstance.handler.get<CommunitySectionsAvailabilityResponse>("/communities/sections-availability")
}
